// The signed-in person, as the account menu and "Your account" show them
// (docs/plans/account-page.md). Their name is changed with `session.updateName`.

/** The server's limit (set_my_name). */
export const NAME_MAX = 80

/** A typed name with its spaces tidied, as the server will keep it. */
export function cleanName(name: string): string {
  return name.trim().replace(/\s+/g, ' ')
}

/** Why a typed name cannot be saved, or null. */
export function nameProblem(name: string): string | null {
  const clean = cleanName(name)
  if (!clean) return 'Type your name'
  if (clean.length > NAME_MAX) return `A name has at most ${NAME_MAX} characters`
  return null
}

interface Person {
  email?: string | null
  user_metadata?: Record<string, unknown> | null
}

/** The name the account carries (typed at sign-up or on "Your account"), or null. */
export function accountName(user: Person): string | null {
  const name = user.user_metadata?.full_name
  return typeof name === 'string' && cleanName(name) ? cleanName(name) : null
}

/** What to call the person: their name, else the part of their email before the @. */
export function displayName(user: Person): string {
  return accountName(user) ?? user.email?.split('@')[0] ?? 'You'
}

/** One or two letters for the round avatar: first and last name, else the email's first. */
export function initialsOf(user: Person): string {
  const words = (accountName(user) ?? '').split(' ').filter(Boolean)
  if (words.length === 0) return (user.email ?? '?').charAt(0).toUpperCase()
  return (words[0]!.charAt(0) + (words.length > 1 ? words.at(-1)!.charAt(0) : '')).toUpperCase()
}

const ARTICLE: Record<string, string> = { owner: 'the owner', admin: 'an admin' }

/** "You are the owner", "You are a waiter". */
export function roleSentence(role: string): string {
  return `You are ${ARTICLE[role] ?? `a ${role}`}`
}
